import React from 'react';
import PropTypes from 'prop-types';

import decode from 'Utils/entities';
import SvgIcon from 'Components/svg/SvgIcon';
import CheckboxComponent from 'Components/common/CheckboxComponent';
import UserIcon from 'Components/common/UserIconComponent';
import Date from 'Components/common/dateComponent';

import { toggleSelectedItem } from 'Actions/MetaActions';

let messagePreviewComponent = ( { pm, users, selectedElements, dispatch } ) => {
	let userFrom = <UserIcon user={ users[ pm.fromUser ] } />,
		msgPreview = decode( pm.messagepreview ),
		usersTo = null;

	if( pm.sent ) {
		let usersTo_list = pm.toUser.map( ( k ) => {
				let onlineStatus = users[ k ].online === true ? <span className="status online"><SvgIcon size="12px" icon="account_circle" /></span> : null;
				return (
					<li className="user-info" key={`toUser_${k}`}>
						<div className="username">{ users[ k ].userName } {onlineStatus}</div>
					</li>
				);
			} );

		usersTo = <div className="usersTo postFooter"><ul>{ usersTo_list }</ul></div>;
	}

	let checked = !!selectedElements[ pm.id ];

	return (
		<div className={ `nolinks thread ${ checked ? 'selected-item' : '' }` }>
			<div className="left">
				{ userFrom }
			</div>
			<div className="right">
				<div className="stats">
					<Date timestamp={ pm.dateline } icon={ true } />
					<CheckboxComponent
						name={ `pmSelect` }
						id={ `pmSelected_${pm.id}` }
						value={ pm.id }
						checked={ checked }
						multiple={ true }
						className={ 'inPost' }
						onChange={ () => dispatch( toggleSelectedItem( pm.id ) ) }
					/>
				</div>
				<div className="title">{ decode( pm.title ) }</div>
				<div className="body topic-preview" id={ `pm_message_${pm.id}` }>
					{ msgPreview } [&hellip;]
				</div>
				{ usersTo }
			</div>
		</div>
	);
};

messagePreviewComponent.propTypes = {
	users: PropTypes.object.isRequired,
	pm: PropTypes.object.isRequired
};

export default messagePreviewComponent;


// WEBPACK FOOTER //
// ./src/components/messages/MessagePreviewComponent.js